import { Button, Card, Col, Form, Input, message, Modal, Popconfirm, Row, Select, Spin, Table, Tag } from "antd"
import { ColumnsType } from 'antd/es/table';
import FileUpload, { FileUploadRef } from "../../../../components/file-input/FileUpload"
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../../api/axiosInstance";
import { DeleteOutlined, EditOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { User } from "../../../../services/users/user";
import FilterHelper from "../../../../utils/Filters/FilterHelper";
import { FilterRequest, OrderTypes, OrderValue } from "../../../../utils/Filters/FilterModels";
import { TableRowSelection } from "antd/es/table/interface";
import dayjs from "dayjs";
const { TextArea } = Input;
const { Option } = Select;

const API_URL = process.env.REACT_APP_API_URL;

const CoachDetailManagement = () => {
    const { coachID } = useParams();

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isAddMemberModal, setIsAddMemberModal] = useState(false);
    const fileUploadRef = useRef<FileUploadRef>(null);
    const [imagePath, setImagePath] = useState<string>();
    const [hasNewImage, setHasNewImage] = useState(false);
    const [formClub] = Form.useForm();
    const [formAddListMember] = Form.useForm();
    const [listCoachReview, setListCoachReview] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [listUser, setListUsers] = useState<any[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const coachImageUploadRef = useRef<FileUploadRef>(null);
    const [coachImage, setCoachImage] = useState<string>();
    const [hasNewCoachImage, setHasNewCoachImage] = useState(false);

    const rowSelection: TableRowSelection<any> = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys, selectedRows) => {
            setSelectedRowKeys(newSelectedRowKeys);
        },
    };

    const [filter, setFilter] = useState<FilterRequest>(new FilterRequest({
        page: 1,
        limit: 1000,
        keyword: '',
        summary: '',
        filters: [],
        orders: [new OrderValue({ propertyName: 'userCode', type: OrderTypes.Desc, index: 0 })
        ],
        isFull: false,
        tree: false,
    }));
    const listMemberColumns: ColumnsType<any> = [
        { title: "coachReviewID", dataIndex: "coachReviewID", key: "coachReviewID", hidden: true },
        {
            title: "Mã người dùng",
            dataIndex: "userCode",
            key: "userCode",
            align: 'center',
            width: 170,
        },
        { title: "NickName", dataIndex: "nickName", key: "nickName", width: 100 },
        { title: "Họ tên", dataIndex: "fullName", width: 170, key: "fullName" },
        { title: "Nội dung đánh giá", dataIndex: "comment", key: "comment" },
        {
            title: "Loại đánh giá",
            dataIndex: "rating",
            key: "rating",
            width: 170,
            render: (rating: number) => {
                const ratingMap: Record<number, { text: string; color: string }> = {
                    1: { text: "Rất tệ", color: "red" },
                    2: { text: "Tệ", color: "volcano" },
                    3: { text: "Ổn", color: "default" },
                    4: { text: "Tốt", color: "blue" },
                    5: { text: "Rất tốt", color: "green" },
                };

                const { text, color } = ratingMap[rating] || { text: "Không xác định", color: "default" };

                return <Tag color={color}>{text}</Tag>;
            }
        },
        {
            title: "Ngày đánh giá",
            dataIndex: "createdDate",
            key: "createdDate",
            align: 'center',
            width: 170,
            render: (date: string) => dayjs(date).format("DD/MM/YYYY")

        }
        // {
        //     title: "Hoạt động",
        //     key: "actions",
        //     render: (record: any) => (
        //         <>
        //             <Popconfirm
        //                 title="Bạn có chắc chắn muốn xóa?"
        //                 onConfirm={() => handleDeleteListMember(record)}
        //                 okText="Có"
        //                 cancelText="Không"
        //             >
        //                 <Button type="link" icon={<DeleteOutlined />} danger />
        //             </Popconfirm>
        //         </>
        //     ),
        // },
    ];

    useEffect(() => {
        if (coachID) {
            fetchClubData();
            fetchListCoachReview();
        }
        const observer = new ResizeObserver(() => { });
        return () => observer.disconnect();
    }, [coachID]);

    const handleUpload = async (): Promise<string | null> => {
        if (hasNewImage) {
            return await fileUploadRef.current?.uploadFile() || null;
        }
        return imagePath?.toString() ?? null;
    };

    const handleUploadImage = async (): Promise<string | null> => {
        if (hasNewCoachImage) {
            return await coachImageUploadRef.current?.uploadFile() || null;
        }
        return coachImage?.toString() ?? null;
    };

    const handleUploadImageSuccess = (newPath: string) => {
        setCoachImage(newPath);
        setHasNewCoachImage(false);
    };
    // Lấy dữ liệu
    const fetchClubData = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/v1/coaches/get-coach-by-ID/${coachID}`);
            const data = response.data;
            formClub.setFieldsValue(data);
            setCoachImage(data.image)
            setData(data)
        } catch (error) {
            message.error("Không thể tải thông tin huấn luyện viên!");
        }
    };
    const fetchListCoachReview = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/v1/coaches/get-list-coach-review-by-coachID/${coachID}`);
            setListCoachReview(response.data);
        } catch (error: any) {
            // message.error(error.response?.data?.systemMessage);
        }
    };

    const handleDeleteListMember = async (record: any) => {
        try {
            await axiosInstance.put(`${API_URL}/v1/coach/delete-list-member`, { coachDetailIds: [record.coachDetailID] });
            message.success("Xoá thành viên thành công!");
            fetchListCoachReview();
        }
        catch (error: any) {
            message.error(error.response?.data);
        }
    }




    const handleCancel = () => {
        navigate("/coach-management");
    };

    const handleConfirm = async () => {
        try {
            const newImagePath = await handleUpload();
            const coachImagePath = await handleUploadImage();

            const values = formClub.getFieldsValue();
            const payLoad = {
                coachCode: values.coachCode,
                coachName: values.coachName,
                address: values.address,
                introduction: values.introduction,
                contact: values.contact,
                playTime: values.playTime,
                facebook: values.facebook,
                zalo: values.zalo,
                instructionArea: values.instructionArea,
                phoneNumber: values.phoneNumber,
                image: coachImagePath,
                attachmentFile: newImagePath
            };

            await axiosInstance.put(`${API_URL}/v1/coaches/update-coach/${coachID}`, payLoad);

            message.success("Cập nhật huấn luyện viên thành công!");
            navigate("/coach-management");
        }
        catch (error: any) {
            message.error(error?.response.data.data);
        }
    };
    return (
        <div style={{ padding: "20px" }}>
            <Form layout="vertical" form={formClub}>
                <Card>
                    <div className="p-6 bg-white rounded-lg shadow-md">
                        <h3 className="text-lg font-semibold mb-4">Thông tin chung</h3>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item
                                            label={<strong>Chọn huấn luyện viên</strong>}
                                            name="userCode"
                                            rules={[{ required: true, message: 'Vui lòng chọn huấn luyện viên' }]}
                                        >
                                            <Select
                                                placeholder="Vui lòng chọn huấn luyện viên"
                                                showSearch
                                                disabled
                                            >
                                                {listUser.map((user) => (
                                                    <Option key={user.id} value={user.id}>
                                                        {user.userCode} - {user.nickName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item
                                            label={<strong>NickName</strong>}
                                            name="nickName"
                                        >
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item
                                            label={<strong>Họ tên huấn luyện viên</strong>}
                                            name="fullName"
                                        >
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item
                                            label={<strong>Điểm đơn</strong>}
                                            name="point"
                                        >
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item
                                            label={<strong>Điểm đôi</strong>}
                                            name="doublePoint"
                                        >
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <div style={{ marginBottom: 20, height: 240 }}>
                                            <FileUpload
                                                expectedWidth={2560}
                                                expectedHeight={1440}
                                                width={376}
                                                height={240}
                                                ref={coachImageUploadRef}
                                                unit="coach"
                                                type="coachImage"
                                                initialFilePath={coachImage}
                                                onUploadSuccess={handleUploadImageSuccess}
                                                onFileSelected={() => setHasNewCoachImage(true)} />
                                        </div>
                                        <p className="text-gray-500 text-sm" >Tải lên hình ảnh với kích thước 356*200</p>
                                    </Col>
                                    <Col span={16}>
                                        <Form.Item label={<strong>Facebook</strong>} name="facebook">
                                            <Input placeholder="https://www.facebook.com" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label={<strong>Số Zalo</strong>} name="zalo">
                                            <Input placeholder="Nhập số Zalo" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label={<strong>Khu vực dạy</strong>} name="instructionArea">
                                            <TextArea rows={2} placeholder="Nhập khu vực dạy" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label={<strong>Giới thiệu về huấn luyện viên</strong>} name="introduction">
                                            <TextArea rows={4} placeholder="Giới thiệu về huấn luyện viên" />
                                        </Form.Item>
                                    </Col>
                                    {/* <Col span={24}>
                                        <Form.Item label={<strong>Thành tích của huấn luyện viên</strong>} name="achievement">
                                            <TextArea rows={4} placeholder="Thành tích của huấn luyện viên" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label={<strong>Ghi chú</strong>} name="description">
                                            <TextArea rows={4} placeholder="Ghi chú" />
                                        </Form.Item>
                                    </Col> */}
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </Card>
                <Card title="Danh sách đánh giá" style={{ marginBottom: 16 }}>
                    <Button icon={<ReloadOutlined />} style={{ marginLeft: 10, marginBottom: 10 }} onClick={() => fetchListCoachReview()}>Làm mới</Button>
                    {loading ? (
                        <Spin fullscreen tip="Đang tải dữ liệu..." size="large" />
                    ) : (<Table rowKey={(record) => record.coachDetailID} rowSelection={rowSelection} dataSource={listCoachReview} columns={listMemberColumns} pagination={false} scroll={{ y: 200 }}
                    />)}
                </Card>
            </Form>
            <div style={{ display: "flex", justifyContent: "end", marginTop: 16, marginRight: 20 }}>
                <Button style={{ marginRight: 10, backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} onClick={handleCancel}>Huỷ</Button>
                <Button style={{ marginBottom: 10, backgroundColor: "#F48100", borderColor: "#F48100" }} type="primary" onClick={handleConfirm}>Xác nhận</Button>
            </div>
        </div>
    )
}
export default CoachDetailManagement